import {
	Chart,
	ArcElement,
	LineElement,
	BarElement,
	PointElement,
	BarController,
	BubbleController,
	DoughnutController,
	LineController,
	PieController,
	PolarAreaController,
	RadarController,
	ScatterController,
	CategoryScale,
	LinearScale,
	LogarithmicScale,
	RadialLinearScale,
	TimeScale,
	TimeSeriesScale,
	Decimation,
	Filler,
	Legend,
	Title,
	Tooltip
  } from 'chart.js';

  
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.plugins.register(ChartDataLabels);

var formatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
	maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

function initializeChartPie(elementId, type = 'pie', money = false) {
	var ctx = document.getElementById(elementId);
	new Chart(ctx, {
		type,
		options: {
			legend: {
				position: 'top',
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc && arc.custom || {};
								var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

								// We get the value of the current label
								var value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];
								var text = money ? label + " : " + formatter.format(value) : label + " : " + value

								return {
									// Instead of `text: label,`
									// We add the value to the string
									text,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
									index: i
								};
							});
						} else {
							return [];
						}
					}
				}
			},
			plugins: {
				datalabels: {
					formatter: function(value, context) {
						if (money) {
							return formatter.format(value)
						}else {
							return value
						}
					}
				}
			},
		},
		data: {
			labels: JSON.parse(ctx.dataset.quotationslabels),
			datasets: [{
				label: '#',
				data: JSON.parse(ctx.dataset.quotationsvalues),
				backgroundColor: [
					"#1D1D1C", "#8A601A", "#F9B233" , "#e6896b" , "#33FF36" ,"#336BFF" , "#0F1B3A" , "#3A0F1E", "#AD798B"
				],
				datalabels: {
					color: '#fff',
					font: {
						size: '16',
						weight: "bold"
					}
				}
			}]		
		},
		plugins: [{
			beforeInit: function(chart, options) {
				chart.legend.afterFit = function() {
					this.height += 50;
				};
			}
		}]
	});
}

export { initializeChartPie } 